module.exports = __webpack_public_path__ + "static/img/module_title.6b37ee27.png";